<div class="bd-input search d-flex justify-content-end">
    <input type="text" id="input" required="" inputSanitizer maxlength="100"
        [ngClass]="searchText && searchText.length > 0 ? 'filled': '' " [(ngModel)]="searchText"
        (input)="emitSearchText()">
    <mat-icon class="search">search</mat-icon>
    <label for="input" class="label" [ngClass]="searchText && searchText.length > 0 ? 'filled': '' ">{{
        'INSTITUTION_MANAGEMENT.SEARCH' |
        translate}}</label>
    <button class="clean" (click)="clearSearchText()"><mat-icon>close</mat-icon></button>
    <div class="underline"></div>
</div>